import { useContext, createContext, useState, useEffect } from 'react'

import type { ToggleDeleteModalEvent } from '@space-lib-events/toggleDeleteModal'
import {
  toggleDeleteModalOldEventDispatch,
  toggleDeleteModalOldEventListener
} from '@space-lib-events/toggleDeleteModalOld'

import type {
  DeleteCommunityModalOldContextProps,
  DeleteCommunityModalOldProviderProps
} from './types'

import DeleteCommunityModalOld from '../..'

const DeleteCommunityModalOldContext = createContext<DeleteCommunityModalOldContextProps>(
  {} as DeleteCommunityModalOldContextProps
)

export const DeleteCommunityModalOldProvider = ({
  children
}: DeleteCommunityModalOldProviderProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [communityId, setCommunityId] = useState<number>()

  useEffect(() => {
    toggleDeleteModalOldEventListener((event) => {
      const payload = (event as CustomEvent<ToggleDeleteModalEvent>).detail
      if (!payload.action && payload.communityId === undefined) {
        return
      }
      switch (payload.action) {
        case 'close':
          setIsOpen(false)
          break
        case 'open':
          setIsOpen(true)
          break
      }
      setCommunityId(payload.communityId)
    })
  }, [])
  const handleDelete = (communityId: number) => {
    toggleDeleteModalOldEventDispatch({ action: 'open', communityId })
  }

  const handleClose = () => {
    toggleDeleteModalOldEventDispatch({ action: 'close' })
  }

  return (
    <DeleteCommunityModalOldContext.Provider
      value={{
        handleDelete,
        handleClose,
        communityId: Number(communityId),
        isOpen
      }}>
      <DeleteCommunityModalOld
        isOpen={isOpen}
        communityId={communityId ?? 0}
        closeModal={handleClose}
      />
      {children}
    </DeleteCommunityModalOldContext.Provider>
  )
}

export const useDeleteCommunityModalOld = () => {
  const context = useContext(DeleteCommunityModalOldContext)

  return context
}
